import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline"
import { ReactComponent as Phone } from "@svgs/phone.svg"
import { ReactComponent as Venue } from "@svgs/venue.svg"
import { ReactComponent as VideoConference } from "@svgs/vc.svg"

const meetingTypes = {
  PHONE: { id: 2, image: <Phone className="h-16" />, label: "Telephone", description: "Attend over the phone (we will call you).", badgeColor: "bg-sky-500" },
  VC: { id: 3, image: <VideoConference className="h-16" />, label: "Video Call", description: "Attend with in-app video conferencing.", badgeColor: "bg-lime-500" },
  VENUE: { id: 1, image: <Venue className="h-16" />, label: "Venue", description: "Attend in person.", badgeColor: "bg-purple-500" },
}

const availabilityTypes = {
  AVAILABLE: { id: 1, image: <CheckCircleIcon className="h-10" />, description: "Available for booking.", label: "Available", badgeColor: "bg-green-500", code: "AVAILABLE" },
  DISABLED: { id: 2, image: <XCircleIcon className="h-10" />, description: "Unavailable for booking.", label: "Unavailable", badgeColor: "bg-red-500", code: "DISABLED" },
}

export {
  meetingTypes,
  availabilityTypes,
}